export default __webpack_public_path__ + "static/garamond-medium-a7684445e448165485bf0b2898b8df97.woff";